import { MenuItem, TabPane } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledHeader = styled.div`
display: flex;
align-items: center;
 .title {
  font-size: 21px !important;
 }
`
export const StyledTabPane = styled(TabPane)`
border: none !important;
`
export const StyledMenuItem = styled(MenuItem)`
 .error {
  color: red;
 }
`